export const language = {
  en: {
    'Confirm': 'Confirm',
    "Number of Likes": "Number of Likes",
    "Attachment Download": "Attachment Download",
    "Close": "Close",
  },
  zh: {
    'Confirm': '确认',
    'Number of Likes': '人点赞',
    'Attachment Download': '附件下载',
    'Close': '关闭',
  }
};
